import { useState, Dispatch, SetStateAction } from "react";
import { Box, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SearchBar from "../../components/SearchBar";
import { useNavigate } from "react-router-dom";
import { isValidInput } from "../../utils/validations";

interface RolesTopbarProps {
  setDebouncedSearchTerm: Dispatch<SetStateAction<string>>;
  searchTerm: string;
  setSearchTerm: Dispatch<SetStateAction<string>>;
  setPage: Dispatch<SetStateAction<number>>;
}

const RolesListTopbar: React.FC<RolesTopbarProps> = ({
  setDebouncedSearchTerm,
  searchTerm,
  setSearchTerm,
  setPage,
}) => {
  const navigate = useNavigate();

  return (
    <>
      <div className="table_header">
        <div className="left_s">
          <Box className="search_box">
            <SearchBar
              placeholder="Search..."
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setDebouncedSearchTerm}
              value={searchTerm}
              onCross={() => setSearchTerm("")}
              onChange={(val: any) => {
                if (isValidInput(val.target.value)) {
                  setSearchTerm(val.target.value);
                  setPage(1);
                }
              }}
            />
          </Box>
        </div>
        <div className="right_s">
          <Button
            className="btn btn_primary"
            onClick={() => navigate("/manage-subadmin/roles/add")}
          >
            <AddIcon /> Add Role
          </Button>
        </div>
      </div>
    </>
  );
};

export default RolesListTopbar;
